import { useSubscription } from 'services/hooks';
import { ArtistCounter, UpgradeMessage } from './components';

const HelperText = () => {
  const { hasDistribution } = useSubscription();
  if (hasDistribution) {
    return <ArtistCounter />;
  }

  return <UpgradeMessage />;
};

export default HelperText;
